import { FaCheck } from 'react-icons/fa'
import { Button } from '../../shared/components/Button'
import Hero from '../components/Hero'
import Card from '../components/Card'
import { FormFieldRenderer } from '../../util/formFieldRenderer'
import { API_URL, volunteerFields as fields } from '../../constants'
import { useState } from 'react'
import DialogModal from '../../shared/components/DialogModal'
import { useNavigate } from 'react-router-dom'
import { validateFields } from '../../util/validateField'
import { handleFormChange } from '../../util/handleFormChange'
import { useTranslation } from 'react-i18next'
import { useTranslationService } from '../../util/TranslationContext'
import { ErrorOverlay } from '../../shared/components/Loading'

const GetInvolved = () => {
    const [volunteerData, setVolunteerData] = useState({})
    const [errors, setErrors] = useState({})
    const [isOpen, setIsOpen] = useState(false)
    const navigate = useNavigate()
    const { t } = useTranslation()
    const { translateFields } = useTranslationService()
    const volunteerFields = translateFields(fields, 'volunteer')
    const [error, setError] = useState(null)

    const volunteerTypes = [
        {
            label: t('volunteer.sections.howYouCanHelp.opportunities.0.label'),
            imageSrc:
                'https://images.unsplash.com/photo-1701656827553-01a790f63363?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NTR8fHZvbHVudGVlcnxlbnwwfHwwfHx8MA%3D%3D',
            description: t('volunteer.sections.howYouCanHelp.opportunities.0.description'),
        },
        {
            label: t('volunteer.sections.howYouCanHelp.opportunities.1.label'),
            imageSrc:
                'https://images.unsplash.com/photo-1652971876875-05db98fab376?q=80&w=1129&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
            description: t('volunteer.sections.howYouCanHelp.opportunities.1.description'),
        },
        {
            label: t('volunteer.sections.howYouCanHelp.opportunities.2.label'),
            imageSrc:
                'https://images.unsplash.com/photo-1628717341663-0007b0ee2597?q=80&w=1171&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
            description: t('volunteer.sections.howYouCanHelp.opportunities.2.description'),
        },
    ]

    const reasons = [
        {
            label: t('volunteer.sections.whyVolunteer.reasons.0.label'),
            image: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=800&q=80',
        },
        {
            label: t('volunteer.sections.whyVolunteer.reasons.1.label'),
            image: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=800&q=80',
        },
        {
            label: t('volunteer.sections.whyVolunteer.reasons.2.label'),
            image: 'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=800&q=80',
        },
    ]

    const handleScrollToForm = () => {
        const formSection = document.getElementById('form')
        if (formSection) {
            formSection.scrollIntoView({ behavior: 'smooth' })
        }
    }

    const handleVolunteerData = handleFormChange(setVolunteerData)

    const submitVolunteer = async () => {
        const isValid = validateFields(volunteerFields, volunteerData, setErrors, t)
        if (!isValid) return

        try {
            const response = await fetch(`${API_URL}/join-volunteer`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(volunteerData),
            })

            if (!response.ok) {
                const errorData = await response.json()
                console.error('Submission failed:', errorData)
                setError(`Submission failed: ${errorData}`)
                // Optional: display server-side errors
                return
            }

            const result = await response.json()
            setIsOpen(true)
        } catch (error) {
            setError(`An error occurred: ${error}`)
            console.error('An error occurred:', error)
        }
    }

    return (
        <div>
            <Hero
                title={t('volunteer.hero.title')}
                imageUrl='/img/banners/get_involved.jpeg'
                size='large'
            >
                <p className='mb-8 text-lg text-white'>{t('volunteer.hero.description')}</p>
                <div className='flex justify-between w-full'>
                    <Button variant='secondary' onClick={() => navigate('/projects')}>
                        {t('volunteer.hero.buttons.otherWays')}
                    </Button>

                    <Button variant='primary' onClick={handleScrollToForm}>
                        {t('volunteer.hero.buttons.volunteerNow')}
                    </Button>
                </div>
            </Hero>

            {error && <ErrorOverlay message={error} onClose={() => setError(null)} />}

            <div className='px-4 mx-auto my-8 max-w-7xl'>
                {/* Why Volunteer */}
                {/* <section className='pt-12'>
                    <h2 className='mb-8 text-xl font-bold text-gray-800 sm:text-2xl text-start'>
                        {t('volunteer.sections.whyVolunteer.title')}
                    </h2>

                    <div className='grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3'>
                        {reasons.map((item, index) => (
                            <div
                                key={index}
                                className='relative h-64 overflow-hidden shadow-md rounded-2xl group'
                                style={{
                                    backgroundImage: `url(${item.image})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                }}
                            >
                                <div className='absolute inset-0 transition duration-300 bg-black/50 group-hover:bg-black/60'></div>
                                <div className='relative z-10 flex flex-col items-center justify-center h-full p-4 text-center text-white'>
                                    <div className='p-4 mb-4 bg-gray-700 rounded-full'>
                                        <FaCheck className='text-xl text-white' />
                                    </div>
                                    <p className='text-lg font-semibold'>{item.label}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </section> */}

                {/* <hr className='h-px my-8 bg-gray-300 md:my-16' /> */}

                {/* How You Can Help */}
                {/* <section>
                    <h2 className='mb-8 text-xl font-bold text-gray-800 sm:text-2xl text-start'>
                        {t('volunteer.sections.howYouCanHelp.title')}
                    </h2>

                    <div className='grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3'>
                        {volunteerTypes.map((item, index) => (
                            <Card
                                key={index}
                                imageSrc={item.imageSrc}
                                label={item.label}
                                description={item.description}
                                button={false}
                            />
                        ))}
                    </div>
                </section> */}

                <DialogModal
                    isOpen={isOpen}
                    onClose={() => setIsOpen(false)}
                    title={t('volunteer.sections.volunteerForm.successDialog.title')}
                >
                    <p className='mb-6 text-sm text-gray-600'>
                        {t('volunteer.sections.volunteerForm.successDialog.message')}
                    </p>
                </DialogModal>

                {/* <hr className='h-px my-8 bg-gray-300 md:my-16' /> */}

                {/* Volunteer Form */}
                <section
                    className='max-w-2xl p-4 mx-auto bg-white border shadow-md sm:p-6 rounded-xl'
                    id='form'
                >
                    <h2 className='mb-8 text-xl font-bold text-center text-gray-800 sm:text-2xl'>
                        {t('volunteer.sections.volunteerForm.title')}
                    </h2>
                    <div className='grid grid-cols-1 gap-4 sm:grid-cols-2'>
                        {volunteerFields.map(field => (
                            <div
                                key={field.name}
                                className={
                                    field.name === 'address' ? 'col-span-1 sm:col-span-2' : ''
                                }
                            >
                                <FormFieldRenderer
                                    value={volunteerData[field.name]}
                                    field={field}
                                    onChange={handleVolunteerData}
                                    error={errors[field.name]}
                                />
                            </div>
                        ))}
                    </div>
                    <div className='flex justify-end w-full mt-6'>
                        <Button size='large' onClick={submitVolunteer}>
                            {t('volunteer.sections.volunteerForm.submitButton')}
                        </Button>
                    </div>
                </section>
            </div>
        </div>
    )
}

export default GetInvolved
